import React, { useContext } from 'react'

// @mui material components
import { Autocomplete } from '@mui/material'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'

import MDAvatar from 'components/MDAvatar'
import MDBadge from 'components/MDBadge'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { useAuth } from 'context/auth'
import { FormContext } from 'layouts/business-account/constants'
import { BusinessAccountForm } from 'layouts/business-account/types'
import FormField from 'modules/FormField'

function Details() {
	const { user } = useAuth()
	const formContext = useContext(FormContext)

	const { localForm, setLocalForm, setFormEdited, isNew } = formContext

	const sectionDisabled = user.data.role === 'VIEWER'

	const handleFormUpdate = (value: string, field: keyof BusinessAccountForm['details']) => {
		setLocalForm(prev => ({
			...prev,
			details: {
				...prev.details,
				[field]: value,
			},
		}))
		setFormEdited(true)
	}

	return (
		<Card id="account">
			<MDBox p={2}>
				<Grid container spacing={3} alignItems="center">
					<Grid item xs={12}>
						<MDBox
							display={'flex'}
							flexDirection={'row'}
							justifyContent={'space-between'}
							alignItems={'center'}
						>
							<MDBox display={'flex'} flexDirection={'row'} gap={2} alignItems={'center'}>
								<MDAvatar bgColor="primary" size="xs">
									1
								</MDAvatar>
								<MDTypography variant="h5" fontWeight="medium">
									Account Details
								</MDTypography>
							</MDBox>
							{!isNew && (
								<MDBadge
									variant="contained"
									color={localForm.details.status === 'ACTIVE' ? 'success' : 'error'}
									badgeContent={localForm.details.status}
									container
								/>
							)}
						</MDBox>
					</Grid>
					<Grid item xs={12} sm={6} lg={3}>
						<MDBox
							height="100%"
							mt={0.5}
							lineHeight={1}
							gap={1}
							display={'flex'}
							flexDirection={'column'}
						>
							<MDTypography variant="h5" fontWeight="medium">
								ID
							</MDTypography>
							<FormField
								disabled={sectionDisabled}
								value={localForm.details.reference_id}
								onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
									handleFormUpdate(e.target.value, 'reference_id')
								}}
							/>
						</MDBox>
					</Grid>
					<Grid item xs={12} sm={6} lg={3}>
						<MDBox
							height="100%"
							mt={0.5}
							lineHeight={1}
							gap={1}
							display={'flex'}
							flexDirection={'column'}
						>
							<MDTypography variant="h5" fontWeight="medium">
								Name
							</MDTypography>
							<FormField
								disabled={sectionDisabled}
								value={localForm.details.name}
								onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
									handleFormUpdate(e.target.value, 'name')
								}}
							/>
						</MDBox>
					</Grid>
					<Grid item xs={12} sm={6} lg={3}>
						<MDBox
							height="100%"
							mt={0.5}
							lineHeight={1}
							gap={1}
							display={'flex'}
							flexDirection={'column'}
						>
							<MDTypography variant="h5" fontWeight="medium">
								Start Date
							</MDTypography>
							<FormField
								disabled={sectionDisabled}
								value={localForm.details.startDate}
								inputProps={{ type: 'date' }}
								onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
									handleFormUpdate(e.target.value, 'startDate')
								}}
							/>
						</MDBox>
					</Grid>
					<Grid item xs={12} sm={6} lg={3}>
						<MDBox
							height="100%"
							mt={0.5}
							lineHeight={1}
							gap={1}
							display={'flex'}
							flexDirection={'column'}
						>
							<MDTypography variant="h5" fontWeight="medium">
								Status
							</MDTypography>
							<Autocomplete
								disableClearable
								readOnly={sectionDisabled}
								value={localForm.details.status ?? null}
								options={['ACTIVE', 'INACTIVE']}
								noOptionsText="No member types set"
								onChange={(_, newValue) => {
									handleFormUpdate(newValue, 'status')
								}}
								size="medium"
								renderInput={params => <FormField {...params} />}
							/>
						</MDBox>
					</Grid>
				</Grid>
			</MDBox>
		</Card>
	)
}

export default Details
